export default "__VITE_ASSET__BdIXPM6a__"